import getEnv from "./getEnv";
import { Environ } from "./types";

const isProd = (): boolean => {
  return getEnv() === Environ.PROD;
};

export default isProd;
